
import { BrowserRouter as Router,Routes, Route } from 'react-router-dom';
import Memberships from './components/MemberShip/Memberships';
import Flights from './components/Flights/Flights';
import Destination from './components/Destination/Destination';
import Bookings from './components/Bookings/Bookings';
import Home from './components/Home/Home';
import Hotels from './components/Hotels/Hotels';
import HotelDetail from './components/Hotels/HotelDetail';
import LoginSignup from './components/Authentication/LoginSignup';
import TopBar from './common/TopBar';
import AboutUs from './components/AboutUs/AboutUs';
import BlogPage from './components/Blog/BlogPage';
import PackageDetail from './common/PackageDetail';
import PaymentGateway from './components/Payment/PaymentGateway';
import MembershipDashboard from './components/MemberShip/MembershipDashboard';
import MembershipDetailPage from './components/MemberShip/MembershipDetailPage';
import DestinationDetailPage from './components/Destination/DestinationDetailPage';
import AuthPage from './components/Authentication/AuthPage';
import OTPAuthentication from './components/Authentication/OTPAuthentication';
import GiftCardPage from './common/GiftCardPage';
import NewsEventDetailedPage from './components/News&Events/NewsEventDetailed';
import BookingCheckoutPage from './components/Bookings/BookingCheckoutPage';
import NGOServicePage from './components/NGO/NGO';
import TermsAndConditions from './common/termAndConditions';
import PrivacyPolicy from './common/privacyPolicies';
import RefundPolicy from './common/refundPolicy';
import MyBookings from './components/MyProfile/MyBookings';
import MyMembership from './components/MyProfile/MyMembership';
import UpdateProfile from './components/MyProfile/UpdateProfile';
import UpdateDocument from './components/MyProfile/UpdateDocument';
import BlogComponent from './components/Blog/BlogComponent';
import AddHotelPage from './components/Hotels/AddHotelPage';
import HotelList from './components/Hotels/HotelList';
import HotelDetailPage from './components/Hotels/HotelDetailPage';
import BookingPage from './components/Bookings/BookingPage';
import HotelDetailPage2 from './components/Hotels/HotelDetailPage2';
import PackageDetailPage from './components/MemberShip/PackageDetailPage';
import OTPLogin from './components/Authentication/OTPLogin';

function App() {
  return (
    <Router>
        <div className="App">
          <Routes>
            <Route exact path='/' element={<Home/>}></Route>
            <Route exact path='/destination' element={<Destination/>}></Route>
            <Route exact path='/booking' element={<Bookings/>}></Route>
            <Route exact path='/flight' element={<Flights/>}></Route>
            <Route exact path='/hotel' element={<Hotels/>}></Route>
            <Route exact path='/addHotel' element={<AddHotelPage/>}></Route>
            <Route exact path='/membership' element={<MembershipDetailPage/>}></Route>
            {/* <Route exact path='/hotel/:Id' element={<HotelDetail/>}></Route> */}
            <Route exact path="/hotelList" element={<HotelList/>} />
      <Route exact path="/hotels/:id" element={<HotelDetailPage />} />
      <Route exact path="/book/:id" element={<BookingPage />} />
            <Route exact path='/login' element={<OTPAuthentication/>}></Route>
            <Route exact path='/aboutUs' element={<AboutUs/>}></Route>
            <Route exact path='/blog' element={<BlogPage/>}></Route>
            <Route path="/blog/:slug" element={<BlogComponent />} />
            <Route path="/packages/:location" element={<PackageDetail />} />
            <Route exact path='/payment' element={<PaymentGateway/>} />
            <Route exact path='/memberComponent' element={<Memberships/>} />
            <Route exact path='/membershipDetailPage' element={<MembershipDetailPage/>} />
            <Route exact path='/packageDetailPage' element={<PackageDetailPage/>} />
            <Route path="/destination/:destinationId" element={<DestinationDetailPage />} />
            <Route exact path='/giftcards' element={<GiftCardPage/>}/>
            <Route  path='/news-and-events/:id' element={<NewsEventDetailedPage/>}/>
            <Route exact path='/booking-checkout' element ={<BookingCheckoutPage />} />
            <Route exact path='/Ngo' element={<NGOServicePage/>}/>
            <Route exact path='/termAndCondition' element={<TermsAndConditions/>}/>
            <Route exact path='/privacyPolicies' element ={<PrivacyPolicy/>}/>
            <Route exact path='/refundPolicy' element ={<RefundPolicy/>}/>
            <Route exact path='/myBookings' element ={<MyBookings/>}/>
            <Route exact path='/myMembership' element ={<MyMembership/>}/>
            <Route exact path='/updateProfile' element ={<UpdateProfile/>}/>
            <Route exact path='/updateDocument' element ={<UpdateDocument/>}/>

          </Routes>
      
      </div>
    </Router>
    
  );
}

export default App;
